<button
  #buttonFilterElement
  accredible-button-outline
  [size]="size"
  [color]="'natural'"
  [icon]="icon"
  [iconSize]="'11px'"
  [disabled]="disabled"
  [class.selected]="selected || menuOpened"
  [accredibleMenuTriggerFor]="menu"
  [rotateIcon]="rotateIcon && menuOpened"
  (menuToggled)="onMenuToggle($event)">
  <ng-content select="[buttonFilterText]"></ng-content>
</button>

<accredible-menu
  #menu
  [customClass]="'accredible-button-filter-menu'"
  [closeMenuOnClick]="closeMenuOnClick">
  <div class="accredible-button-filter-menu-content" [style.width]="menuWidth">
    <ng-content></ng-content>
  </div>
</accredible-menu>
